import { ImageLoader } from 'next/image'

export const resizedProductImageLoader: ImageLoader = ({ src, width }) => {
  return `${src}/${width}`
}
